import { Check, Slash } from "@tamagui/lucide-icons";
import { type CheckedState, Checkbox as TamaguiCheckbox } from "tamagui";

export const Checkbox = ({
  checked,
  semiChecked,
  onCheckedChange,
  disabled,
}: {
  checked: boolean;
  semiChecked?: boolean;
  disabled?: boolean;
  onCheckedChange?(checked: CheckedState): void;
}) => {
  return (
    <TamaguiCheckbox
      disabled={disabled}
      onCheckedChange={onCheckedChange}
      checked={checked}
      height={"$size.normal"}
      width={"$size.normal"}
      borderColor={checked ? "$color" : "$divider"}
      backgroundColor={"$backgroundBlock"}
      borderRadius={0}
    >
      <TamaguiCheckbox.Indicator>
        {semiChecked ? (
          <Slash size={"$size.small"} />
        ) : (
          <Check size={"$size.small"} />
        )}
      </TamaguiCheckbox.Indicator>
    </TamaguiCheckbox>
  );
};
